import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";

import AudioRecorder from "../audioWrap/audioWrap";
import { Close } from "@mui/icons-material";

const AudioWrapV2 = ({
  handleChange,
  isAudioOn,
  toggleAudio,
  extraInfo,
  label,
}) => {
  const [fontSize, setFontSize] = useState(16);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleLeftButtonClick = () => {
    setFontSize((prevSize) => Math.max(prevSize - 2, 8));
  };

  const handleRightButtonClick = () => {
    setFontSize((prevSize) => Math.min(prevSize + 2, 40));
  };

  return (
    <Dialog
      open={isAudioOn}
      maxWidth={isMobile ? "sm" : "md"}
      fullWidth
      PaperProps={{
        sx: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "20px",
          p: isMobile ? "10px" : "20px", // Reduce padding for mobile screens
          backgroundColor: "#FFF",
          borderRadius: "4px",
        },
      }}
    >
      <DialogTitle>
        {label}
        <IconButton
          aria-label="close"
          onClick={toggleAudio}
          sx={{
            position: "absolute",
            top: "8px",
            right: "8px",
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          m: isMobile ? "0px" : "16px",
          p: isMobile ? "10px" : "20px",
          width: "100%",
        }}
      >
        {" "}
        {/* Remove margin for mobile screens */}
        <Typography
          variant="body1"
          style={{
            fontSize: `${fontSize}px`,
            maxHeight: "200px",
            overflowY: "auto",
            marginBottom: "20px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {extraInfo}
        </Typography>
        {/* <Slider
      value={fontSize}
      min={12}
      max={60}
      step={2}
      onChange={handleSliderChange}
      sx={{ mt: isMobile ? '10px' : '16px' }} // Reduce margin-top for mobile screens
    /> */}
        <Box display="flex" width="100%" paddingY={"30px"}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={handleLeftButtonClick}
            style={{
              fontSize: `${16}px`,
              width: "50%",
              background: "#E9EDF1",
              borderTopRightRadius: "0",
              borderBottomRightRadius: "0",
              color: "black",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            A-
          </Button>
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={handleRightButtonClick}
            style={{
              fontSize: `${20}px`,
              width: "50%",
              background: "#E9EDF1",
              borderTopLeftRadius: "0",
              borderBottomLeftRadius: "0",
              color: "black",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            A+
          </Button>
        </Box>
        <AudioRecorder handleChange={handleChange} toggleAudio={toggleAudio} />{" "}
        {/* Reduce margin-top for mobile screens */}
      </DialogContent>
    </Dialog>
  );
};

export default AudioWrapV2;
